import {
    Chip,
    DialogContent,
    DialogTitle,
    Divider,
    Modal,
    ModalClose,
    ModalDialog,
    Stack,
    Typography,
    useTheme
} from "@mui/joy";
import React from "react";


const AndroidInstallPromptDialogComponent = () => {
    const ANDROID_INSTALL_STEPS = [
        "Open the page in Chrome",
        "Tap the menu icon top right",
        "Tap Add to Home screen",
        "Tap Add to confirm"
    ]

    return <Modal open={true}>
        <ModalDialog variant="outlined" role="alertdialog" size={"lg"} sx={{minWidth: {xs: "100%", sm: "35rem"}}}>
            <DialogTitle sx={{alignSelf: "center"}}>
                Android Install Required
            </DialogTitle>

            <Divider/>

            <Stack gap={3} direction={"row"} justifyContent={"center"} alignItems={"center"}>
                <AndroidMockup/>

                <Stack gap={1}>
                    {ANDROID_INSTALL_STEPS.map((step, index) =>
                        <Stack gap={1} direction={"row"} alignItems={"center"}>
                            <Chip variant={"solid"} color={"primary"}>
                                {index + 1}
                            </Chip>
                            <Typography level={"body-sm"} textColor={"text.primary"}>
                                {step}
                            </Typography>
                        </Stack>)}
                </Stack>

            </Stack>


            <DialogContent>
                <Typography level={"body-sm"}>
                    For the best experience on Android, install LinguaScore to your home screen. This enables microphone
                    access and audio playback required for the Speaking test.
                </Typography>
            </DialogContent>

        </ModalDialog>
    </Modal>
}

function IOSMockup() {
    const theme = useTheme()

    return (
        <svg width="160" height="240" viewBox="0 0 160 240" fill="none" style={{display: 'block'}}>
            {/* Phone body */}
            <rect x="1" y="1" width="158" height="238" rx="22" fill={theme.palette.background.surface}
                  stroke={theme.palette.background.level2} strokeWidth="1.5"/>

            {/* Notch */}
            <rect x="50" y="0" width="60" height="16" rx="8" fill={theme.palette.background.level2}/>

            {/* Status bar */}
            <rect x="14" y="22" width="132" height="8" rx="2" fill={theme.palette.background.level1}/>

            {/* Browser address bar */}
            <rect x="14" y="35" width="132" height="14" rx="4" fill={theme.palette.background.level2}
                  stroke={theme.palette.divider} strokeWidth="1"/>
            <text x="80" y="45" textAnchor="middle" fontSize="7" fill={theme.palette.text.primary}
                  fontFamily="system-ui">linguascores.com
            </text>

            {/* Page content area */}
            <rect x="14" y="55" width="132" height="110" rx="4" fill={theme.palette.background.level2}/>
            {/* LinguaScore logo in page */}
            <rect x="58" y="68" width="44" height="44" rx="10" fill={theme.palette.primary['500']}/>
            <text x="80" y="96" textAnchor="middle" fontSize="22" fontWeight="800" fill="white"
                  fontFamily="system-ui">L
            </text>
            <rect x="36" y="120" width="88" height="6" rx="3" fill={theme.palette.background.level3}/>
            <rect x="50" y="130" width="60" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="42" y="139" width="76" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="56" y="148" width="48" height="5" rx="2.5" fill={theme.palette.background.level3}/>

            {/* Share sheet */}
            <rect x="0" y="168" width="160" height="70" rx="0" fill={theme.palette.background.level1}/>
            <rect x="0" y="168" width="160" height="70" rx="0" fill={theme.palette.background.level1}
                  stroke={theme.palette.background.level3} strokeWidth="1"/>
            {/* Handle */}
            <rect x="66" y="174" width="28" height="3.5" rx="2" fill={theme.palette.background.level3}/>

            {/* Highlighted row: Add to Home Screen */}
            <rect x="0" y="182" width="160" height="26" fill={theme.palette.background.level2}/>
            {/* Plus-square icon */}
            <rect x="12" y="188" width="14" height="14" rx="3" fill="none" stroke={theme.palette.text.icon}
                  strokeWidth="1.4"/>
            <line x1="19" y1="192" x2="19" y2="199" stroke={theme.palette.text.icon} strokeWidth="1.4"
                  strokeLinecap="round"/>
            <line x1="15.5" y1="195.5" x2="22.5" y2="195.5" stroke={theme.palette.text.icon} strokeWidth="1.4"
                  strokeLinecap="round"/>
            <text x="32" y="198" fontSize="8.5" fill={theme.palette.text.primary} fontFamily="system-ui"
                  fontWeight="600">Add to Home Screen
            </text>

            {/* Second row */}
            <rect x="12" y="212" width="14" height="14" rx="3" fill="none" stroke="#9ca3af" strokeWidth="1.2"/>
            <text x="32" y="222" fontSize="8" fill={theme.palette.text.primary} fontFamily="system-ui">Copy</text>

            {/* Bottom safe area / home indicator */}
            <rect x="58" y="232" width="44" height="4" rx="2" fill={theme.palette.text.secondary}/>
        </svg>
    )
}

function AndroidMockup() {
    const theme = useTheme()

    return (
        <svg width="160" height="240" viewBox="0 0 160 240" fill="none" style={{display: 'block'}}>
            {/* Phone body */}
            <rect x="1" y="1" width="158" height="238" rx="14" fill={theme.palette.background.surface}
                  stroke={theme.palette.background.level3} strokeWidth="1.5"/>

            {/* Status bar */}
            <rect x="0" y="0" width="160" height="20" rx="14" fill={theme.palette.background.level1}/>
            <rect x="0" y="14" width="160" height="6" fill={theme.palette.background.level1}/>

            {/* Chrome toolbar */}
            <rect x="0" y="20" width="160" height="30" fill={theme.palette.background.level2}/>
            <rect x="10" y="27" width="118" height="16" rx="8" fill={theme.palette.background.level3}/>
            <text x="69" y="38" textAnchor="middle" fontSize="7" fill={theme.palette.text.primary}
                  fontFamily="system-ui">linguascores.com
            </text>

            {/* Three-dot menu button */}
            <circle cx="143" cy="31" r="1.8" fill="#6b7280"/>
            <circle cx="143" cy="35.5" r="1.8" fill="#6b7280"/>
            <circle cx="143" cy="40" r="1.8" fill="#6b7280"/>

            {/* Dropdown menu */}
            <rect x="98" y="44" width="58" height="68" rx="6" fill={theme.palette.background.level1}
                  stroke={theme.palette.divider} strokeWidth="1"/>
            {/* Highlighted: Add to Home screen */}
            <rect x="98" y="44" width="58" height="18" rx="6" fill={theme.palette.background.level3}/>
            <rect x="98" y="55" width="58" height="7" fill={theme.palette.background.level3}/>
            <text x="127" y="56" textAnchor="middle" fontSize="6.5" fill={theme.palette.text.primary}
                  fontFamily="system-ui" fontWeight="600">Add to Home screen
            </text>

            <rect x="98" y="63" width="58" height="1" fill={theme.palette.divider}/>
            <text x="127" y="73" textAnchor="middle" fontSize="6.5" fill={theme.palette.text.primary}
                  fontFamily="system-ui">New tab
            </text>
            <rect x="98" y="77" width="58" height="1" fill={theme.palette.divider}/>
            <text x="127" y="87" textAnchor="middle" fontSize="6.5" fill={theme.palette.text.primary}
                  fontFamily="system-ui">Bookmarks
            </text>
            <rect x="98" y="91" width="58" height="1" fill={theme.palette.divider}/>
            <text x="127" y="101" textAnchor="middle" fontSize="6.5" fill={theme.palette.text.primary}
                  fontFamily="system-ui">History
            </text>

            {/* Page content area */}
            <rect x="0" y="50" width="97" height="148" fill={theme.palette.background.surface}/>
            <foreignObject x="25" y="55" width="64" height="64">
                <div style={{
                    width: 60,
                    height: 60,
                    background: theme.palette.primary['500'],
                    borderRadius: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img src={require("../../assets/logo_white.png")} alt="LinguaScore" width={48} height={48}
                         style={{objectFit: 'contain'}}/>
                </div>
            </foreignObject>
            <rect x="14" y="122" width="68" height="6" rx="3" fill={theme.palette.background.level3}/>
            <rect x="22" y="132" width="52" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="18" y="141" width="60" height="5" rx="2.5" fill={theme.palette.background.level3}/>
            <rect x="26" y="150" width="44" height="5" rx="2.5" fill={theme.palette.background.level3}/>

            {/* Android nav bar */}
            <rect x="0" y="198" width="160" height="40" rx="0" fill={theme.palette.background.level1}/>
            <rect x="0" y="235" width="160" height="3" rx="0" fill={theme.palette.background.level1}/>

            {/* Back button (chevron) */}
            <polyline points="58,215 54,219 58,223" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round"
                      strokeLinejoin="round" fill="none"/>

            {/* Home button (circle) */}
            <circle cx="80" cy="219" r="7" fill="none" stroke="#6b7280" strokeWidth="1.5"/>

            {/* Square/recent */}
            <rect x="97" y="212" width="14" height="14" rx="3" fill="none" stroke="#6b7280" strokeWidth="1.5"/>

            {/* Bottom home indicator */}
            <rect x="58" y="234" width="44" height="4" rx="2" fill={theme.palette.text.icon}/>
        </svg>
    )
}


export default AndroidInstallPromptDialogComponent